var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTwitter = function SvgTwitter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.658a5.735 5.735 0 0 1-1.65.452 2.88 2.88 0 0 0 1.263-1.589c-.554.33-1.17.568-1.823.697a2.872 2.872 0 0 0-4.894 2.62 8.153 8.153 0 0 1-5.92-3.001 2.87 2.87 0 0 0 .889 3.834 2.863 2.863 0 0 1-1.302-.359v.036c0 1.392.99 2.552 2.304 2.817a2.888 2.888 0 0 1-1.298.049 2.876 2.876 0 0 0 2.683 1.995A5.764 5.764 0 0 1 3 14.398a8.13 8.13 0 0 0 4.403 1.29c5.282 0 8.171-4.376 8.171-8.171 0-.125-.002-.249-.008-.372A5.849 5.849 0 0 0 17 5.658Z",
    fill: "#1B2230"
  })));
};
export default SvgTwitter;